import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import SignalType from "app/pages/sales-intelligence/sub-modules/signals/models/core/SignalType";
import type { SignalEventDto } from "../../../types/signals";
import { isNewsSignalEvent } from "../../../types/signals";
import { signalTitleTextMap } from "../maps/newsSignalTextMap";

const VALID_SIGNAL_EVENT_TYPES: Set<SignalType> = new Set([
    SignalType.Technology,
    SignalType.AdNetwork,
    SignalType.Traffic,
    SignalType.Ecommerce,
]);

const getValidSignalEventTypesByFeature = (): ReadonlySet<SignalType> => {
    return salesSettingsHelper.isIntentSignalsEnabled()
        ? new Set([...VALID_SIGNAL_EVENT_TYPES, SignalType.Intent])
        : VALID_SIGNAL_EVENT_TYPES;
};

const getValidSignalEvents = (signalEvents: readonly SignalEventDto[] | undefined): SignalEventDto[] => {
    if (!signalEvents) {
        return [];
    }

    const validSignalEventTypes = getValidSignalEventTypesByFeature();

    return signalEvents.filter((signal) => {
        if (isNewsSignalEvent(signal)) {
            const subtype = signal.categories[0];
            const signalTitleTextMapValue = signalTitleTextMap[subtype];

            return !!signalTitleTextMapValue;
        }

        return validSignalEventTypes.has(signal.type);
    });
};

export default getValidSignalEvents;
